// intentChoiceStorage — persister användarens senaste IntentSelector-val
// i localStorage. Pure accessor-par — ingen React-kontext — så både
// vitest och SSR kan hantera.
//
// Se IMPROVEMENTS_m.md I-006.

import type { IntentChoice } from '@/components/workflow/IntentSelector';
import { INTENTS } from '@/lib/intentTypes';

const STORAGE_KEY = 'engicoro-ai-last-intent';
const VALID_VALUES: readonly IntentChoice[] = ['auto', ...INTENTS];

/**
 * Läs senaste sparade IntentChoice. Defaultar till 'auto' vid:
 * - saknad localStorage (desktop/SSR)
 * - obefintlig nyckel
 * - korrumperat värde (t.ex. gammalt intent-namn som inte finns i INTENTS)
 */
export function loadIntentChoice(): IntentChoice {
  try {
    const raw = typeof localStorage !== 'undefined'
      ? localStorage.getItem(STORAGE_KEY)
      : null;
    if (!raw) return 'auto';
    if ((VALID_VALUES as readonly string[]).includes(raw)) {
      return raw as IntentChoice;
    }
    return 'auto';
  } catch {
    return 'auto';
  }
}

/**
 * Spara aktuellt val. Swallar fel tyst — persistering är QoL, ej kritisk.
 */
export function saveIntentChoice(choice: IntentChoice): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    /* Quota exceeded / private-mode — ignore. */
  }
}

export { STORAGE_KEY as INTENT_CHOICE_STORAGE_KEY };
